export const useStyles = {
  circleBox: {
    borderRadius: "50%",
    width: { sm: "200px", xs: "120px" },
    height: { sm: "200px", xs: "120px" },
    border: "solid 8px",
    position: "relative",
  },
  icon: {
    position: "absolute",
    top: "-28px",
    right: -25,
    width: { md: "100px", xs: "70px" },
  },
  bottomBadge: {
    position: "absolute",
    bottom: "-20px",
    left: "-20px",
    background: "white",
    border: "solid 3px",
    borderRadius: "50%",
    width: { md: "100px", xs: "70px" },
    height: { md: "100px", xs: "70px" },
  },
};
